import _flatMapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat-map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import { identificationsPageBindingsAndVisibilities } from "@Client/@Composables/application-standalone/pages/identifications/identificationsPageBindingsAndVisibilities";
import { getValidationRulesFromMap } from "@Client/@Composables/application-standalone/validations/getValidationRulesFromMap";
import { computed, ref } from "@vue/composition-api";
import { useVuelidate } from "@vuelidate/core";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import { useApplicantHelpers } from "../pages/applicants/useApplicantHelpers";
import { camelCase, capitalize, mapKeys } from "lodash";
export const identificationValidator = (applicantIndex, identificationIndex, {
  lazy = false
} = {}) => {
  const {
    bindings
  } = identificationsPageBindingsAndVisibilities(applicantIndex, identificationIndex, ref("0"));
  const {
    identificationType,
    identificationCountry,
    identificationNumber
  } = bindings;
  const applicantPrefix = computed(() => {
    return applicantIndex.value ? "applicant" : "";
  });
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut,
    getApplicantIdByIndex
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = () => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(getApplicantIdByIndex(applicantIndex.value));
  const rules = computed(() => {
    return getValidationRulesFromMap(areRulesVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, identificationPageRules, applicantPrefix.value);
  });
  const v$ = useVuelidate(rules, {
    identificationType,
    identificationCountry,
    identificationNumber
  }, {
    $scope: true,
    $lazy: lazy
  });
  return {
    v$
  };
};
const identificationPageRules = {
  identificationType: {},
  identificationCountry: {},
  identificationNumber: {}
};
export const identificationsValidator = ({
  lazy = true
} = {}) => {
  const {
    allIdentifications: identifications
  } = useApplicantHelpers();
  const {
    GET_SCHEMA_RULES_BY_PATH,
    HAS_CONSOLIDATED_REQUEST
  } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.GET_SCHEMA_RULES_BY_PATH, ApplicationStandaloneGetters.HAS_CONSOLIDATED_REQUEST]);
  const {
    isApplicantVisibleFromFillOut
  } = useApplicantHelpers();
  const areRulesVisibleFromFillOut = ({
    id,
    applicantId
  }) => !HAS_CONSOLIDATED_REQUEST.value || isApplicantVisibleFromFillOut(id || applicantId);
  const allIdentifications = computed(() => {
    var _context;
    return _flatMapInstanceProperty(_context = identifications.value).call(_context, item => areRulesVisibleFromFillOut(item) ? mapKeys(item, (_value, key) => camelCase("identification" + capitalize(key))) : []);
  });
  const getRules = () => {
    var _context2;
    const mainApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, identificationPageRules);
    const coApplicantRules = getValidationRulesFromMap(() => true, GET_SCHEMA_RULES_BY_PATH, identificationPageRules, "applicant");
    return _reduceInstanceProperty(_context2 = allIdentifications.value).call(_context2, (acc, _identification, index) => {
      acc[index] = _identification.applicantIndex ? coApplicantRules : mainApplicantRules;
      return acc;
    }, {});
  };
  const rules = computed(getRules);
  const v$ = useVuelidate(rules, allIdentifications, {
    $scope: "identificationArray",
    $lazy: lazy
  });
  return {
    v$
  };
};